import React, { FC } from 'react'
import MediaQuery from 'react-responsive'
import { md } from '@styles/variables/breakpoints'
import { SH2 } from '@components/Typography'
import { SNumber } from '@components/HowToGet/Steps'
import { IStep, steps } from '@components/HowToParticipate/data'
import { colors } from '@styles/theme'
import Box from '@components/Box'
import Arrow from '@icons/stepArrow.inline.svg'
import { SButton, SContainer, SStep, SSubTitle, SText } from '@components/HowItWorksOnAero/SComponents'
import WithSlider from '@components/HowItWorksOnAero/WithSlider'

interface IProps {
  heading: string
}

const HowToParticipate: FC<IProps> = ({ heading }) => {
  return (
    <>
      <SH2 mb={{ _: '20px', md: '32px' }}>{heading}</SH2>
      <MediaQuery minWidth={md}>
        <Box
          display="flex"
          flexDirection="row"
          overflowX={{ md: 'auto', xl: 'visible' }}
          width={{ md: '100%' }}
          pr={{ md: '40px', xl: 0 }}
        >
          <SContainer>
            {steps.map(({ heading, content, link }: IStep, index) => (
              <SStep key={index}>
                <Box display="flex" alignItems="center" mb="12px">
                  <SNumber color={colors.darkBlue}>{index + 1}</SNumber>
                  {index !== steps.length - 1 && <Arrow />}
                </Box>
                <SSubTitle>{heading}</SSubTitle>
                <SText>{content}</SText>
                {link && index === 0 && (
                  <SButton href={link.url} link mt={{ _: 'auto' }} target="_blank">
                    {link.text}
                  </SButton>
                )}
              </SStep>
            ))}
          </SContainer>
        </Box>
      </MediaQuery>
      <MediaQuery maxWidth={md - 1}>
        <Box mx="-20px">
          <WithSlider />
        </Box>
      </MediaQuery>
    </>
  )
}

export default HowToParticipate
